import { EntityRepository, Repository } from "typeorm";
import { TypesOfLeaves } from "../types-of-leaves.entity";

@EntityRepository(TypesOfLeaves)
export class TypesOfLeavesRepository extends Repository<TypesOfLeaves> {


}